export * from './IconMapStroked';
